/* External dependencies */
import { Button, Div, Text } from 'atomize';
import { OutboundLink } from 'gatsby-plugin-google-gtag';
import { Trans } from 'gatsby-plugin-react-i18next';
import React from 'react';

/* Local dependencies */
import AppStoreIcon from '../../../svg/AppStoreIcon';
import GooglePlayIcon from '../../../svg/GooglePlayIcon';

export interface DownloadAppButton {
  link: string;
  onClick?: () => void;
  paddingButton?: string | object;
  paddingRightForText?: string | object;
  store: 'android' | 'apple';
  textSizeApp?: string | object;
  textSizeDownload?: string | object;
}

export default function DownloadAppButtons({
  link,
  onClick,
  paddingButton = { y: '25px', x: '10px' },
  paddingRightForText = { r: { xs: '0', sm: '20px' } },
  store,
  textSizeApp = '20px',
  textSizeDownload = '10px',
}: DownloadAppButton) {
  function sendEventToAnalytics() {
    if (typeof window !== undefined && process.env.NODE_ENV === 'production') {
      if (store === 'android') {
        window.gtag('event', 'click_google_play', {
          event_name: 'click',
        });
      } else {
        window.gtag('event', 'click_app_store', {
          event_name: 'click_app_store',
        });
      }
    }
  }

  return (
    <OutboundLink href={link} target="_blank" onClick={onClick}>
      <Button
        p={paddingButton}
        bg="#000"
        d="flex"
        justify="start"
        align="center"
        style={{ gap: '5px' }}
        onClick={sendEventToAnalytics}
        className={`${store}-app`}
      >
        <Div d="flex">
          {store === 'apple' ? (
            <AppStoreIcon fill="#fff" />
          ) : (
            <GooglePlayIcon />
          )}
        </Div>
        <Div
          d="flex"
          flexDir="column"
          textAlign="start"
          style={{ gap: '3px' }}
          p={paddingRightForText}
        >
          <Text
            tag="p"
            textSize={textSizeDownload}
            textColor="white"
            textWeight="600"
            textTransform={store === 'android' && 'uppercase'}
            style={{ whiteSpace: 'nowrap' }}
          >
            {store === 'apple' ? (
              <Trans>downloadButtonAndroidText</Trans>
            ) : (
              <Trans>downloadButtonAppleText</Trans>
            )}
          </Text>
          <Text
            tag="p"
            textSize={textSizeApp}
            textWeight="600"
            style={{ whiteSpace: 'nowrap' }}
          >
            {store === 'apple' ? 'App Store' : 'Google Play'}
          </Text>
        </Div>
      </Button>
    </OutboundLink>
  );
}
